export default {
	accounts: JSON.parse(localStorage.getItem("campaignAccounts")) || [],
	assignedAccounts: [],
};
